import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class BecnhmarkWeight extends AppRecord {
  get issue(){
    return this.constructor.employeeStore.issues.find(iss => iss.id === this.issue_id)||{}
  }
  get benchmark_issue(){
    return this.constructor.employeeStore.issues.find(iss => iss.id === this.benchmark_id)||{}
  }
  get benchmark_setup(){
    return this.constructor.employeeStore.benchmark_setups.find(set => set.id === this.benchmark_setup_id)||{}
  }
  get formatted_weight(){
    return this.weight * 10000 / 100
  }

  set formatted_weight(value){
    this.weight = value != 0 ? value /100 : 0
  }

  get description(){
    return this.issue_id + " - " + this.issue.name + " (" + this.issue.asset_class_group?.name + ")"
  }

  get asset_class_group_name(){
    return this.issue.asset_class_group?.name
  }

  get asset_class(){
    return this.issue.asset_class
  }
}
export default BecnhmarkWeight
